// extracted by mini-css-extract-plugin
export default {"labels":"lsf-labels","labels_hidden":"lsf-labels_hidden","labels_inline":"lsf-labels_inline"};
    if(module.hot) {
      // 1637785521497
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  